class MiniCart extends HeaderMenu {
  constructor() {
    super();
    this.isDisabled = this.attributes.hasOwnProperty('disabled');
    this.lensadvizorPostAddToCart();
  }

  onFocusOut() {
    return;
  }

  onMouseEnter() {
    if (this.mainDetailsToggle.open || this.isDisabled) return;
    this.open();
  }

  onSummaryClick(event) {
    if (!this.mql.matches || this.isDisabled) {
      event.preventDefault();
    }
  }

  lensadvizorPostAddToCart() {
    setTimeout(() => {
      if (typeof _lensadvizorEmbed === 'object' && typeof _lensadvizorEmbed.getCartData === 'function') {
        const cartData = _lensadvizorEmbed.getCartData();
        _lensadvizorEmbed.updateCart(cartData, true);

        if (window.LensAdvizor) {
          LensAdvizor.postAddToCart = (cartContent) => {
            const sections = this.getSectionsToRender()
              .map((section) => section.id)
              .join();
            setTimeout(() => {
              const sectionData = _lensadvizorEmbed.makeRequest(
                'GET',
                routes.cart_url + '?sections=' + sections + '&sections_url=' + window.location.pathname
              );
              cart.renderContents({ sections: sectionData, id: LensAdvizor.selectedOrDefaultVariant });
              if (cart.classList.contains('is-empty')) cart.classList.remove('is-empty');
            }, 10);
          };
        }
      }
    }, 500);
  }
}

customElements.define('mini-cart', MiniCart);

class MiniCartItems extends CartItems {
  getSectionsToRender() {
    return [
      {
        id: 'mini-cart',
        section: 'mini-cart',
        selector: '.mini-cart__inner',
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section',
      },
    ];
  }
}

customElements.define('mini-cart-items', MiniCartItems);